module.exports = __webpack_public_path__ + "img/ics_o_delivery_process.fef21784.svg";